import { useEffect, useState } from "react";
import { GET_ALL_HOME_FORUM, fetchData } from "../../../components/Service";
import { Link } from "../../../../node_modules/react-router-dom/dist/index";
import _ from "lodash";
import moment from "../../../../node_modules/moment/moment";

const Forum = () => {
	const [forum, setForum] = useState([]);

	const getForum = () => {
		fetchData(GET_ALL_HOME_FORUM, "GET", "", false, false, (res) => {
			if (res.status) {
				setForum(res?.data);
			} else {
				console.log(res);
			}
		});
	};

	useEffect(() => {
		getForum();
	}, []);
	return (
		<div class="col-xl-4 col-lg-4 mb-1">
			<div class="card card-forum h-100">
				<div class="card-header usa-bg">
					<div className="national-bg">
						<h4 class="text-white d-flex ind1">Forum</h4>
					</div>
				</div>
				<div class="card-body bg-white h-100 news_scroll p-1">
					<div class="table-responsive">
						{forum?.result?.map((item) => (
							<>
								<table class="table table-borderless table-sm align-middle">
									<tr>
										<td class="align-middle">
											<h5 class="fw-bold orangec">Recent Post</h5>
										</td>
										<td class="text-end">
											<img src="/assets/images/ping.png" class="flag_map_icon" alt="..." />
											{item.country_id ? (
												<>
													{item.country_id.id === 1 && <img src="/assets/images/usa.png" class="flag_map_icon" alt="..." />}
													{item.country_id.id === 2 && <img src="/assets/images/canada.png" class="flag_map_icon" alt="..." />}
													{item.country_id.id === 3 && <img src="/assets/images/aus.png" class="flag_map_icon" alt="..." />}
													{item.country_id.id === 4 && <img src="/assets/images/nzl.png" class="flag_map_icon" alt="..." />}
													{item.country_id.id === 10 && <img src="/assets/images/uk.png" class="flag_map_icon" alt="..." />}
												</>
											) : (
												""
											)}
										</td>
									</tr>
									{item?.forum?.slice(0, 6)?.map((forumItem) => (
										<tr key={forum.id}>
											<td>
												<Link to={`/forums/${forumItem.id}`}>{_.truncate(forumItem.title, { length: 35 })}</Link>
											</td>
											<td class="text-end text-nowrap">{forumItem.created_at ? moment(forumItem.created_at).format("DD-MMM-YYYY") : ""}</td>
										</tr>
									))}
								</table>
								<hr />
							</>
						))}
					</div>
				</div>
				<div class="card-footer text-end py-1">
					<span class="font16 fw-normal ms-auto">
						<Link to={`/forums`} class="text-decoration-underline font11">
							View More
						</Link>
					</span>
				</div>
			</div>
		</div>
	);
};

export default Forum;
